export const Languages = {
    //ServerName: 'DisplayName',
    None: 'None',
    Cantonese: 'Cantonese',
    English: 'English',
    French: 'French',
    HaitianCreole: 'Haitian Creole',
    Hmong: 'Hmong',
    Japanese: 'Japanese',
    Korean: 'Korean',
    Mandarin: 'Mandarin',
    Marshallese: 'Marshallese',
    PortugueseBrazil: 'Portuguese (Brazil)',
    Russian: 'Russian',
    Somali: 'Somali',
    Spanish: 'Spanish',
    Tagalog: 'Tagalog',
    Vietnamese: 'Vietnamese',
    Arabic: 'Arabic',
    Ukrainian: 'Ukrainian',
    Dari: 'Dari',
    Pashto: 'Pashto',
    Farsi: 'Farsi',
    Chuukese: 'Chuukese',
    Armenian: 'Armenian'
};



// WEBPACK FOOTER //
// ./src/constants/languages.js